<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("form_view") }}</h5>
      <!-- <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button> -->
    </template>
    <template slot="body">
      <div class="card card-with-search border-0 card-with-shadow">
        <div class="text-justify">
          <div class="row">
            <!-- <dynamic-form-preview v-bind:Id="id"></dynamic-form-preview> -->
            <div class="col-sm-8">
              <div class="main__wrapper">
                <el-container>
                  <el-main :style="cssProps">
                    <el-form>
                      <template v-for="(eachFormObj, eachFormIndex) in forms">
                        <el-divider :key="`divider-${eachFormIndex}`">{{
                          eachFormObj.title
                        }}</el-divider>
                        <el-row :key="`row-${eachFormIndex}`">
                          <div class="wrapper--forms">
                            <el-col
                              v-for="(field, index) in eachFormObj.fields"
                              :key="index"
                              :span="field.span"
                              v-bind="field"
                              class="form__group"
                              :class="{
                                'is---active':
                                  componentFieldId === field.componentId,
                              }"
                            >
                              <!-- :class="{ 'is--active': field === activeField }" -->
                              <!-- <label class="form__label" v-model="form.label" v-show="form.hasOwnProperty('label')">{{ form.label }}</label> -->
                              <div @click="editElementProperties(field)">
                                <component
                                  :class="{
                                    'is---active':
                                      componentFieldId === field.componentId,
                                  }"
                                  :is="field.fieldType"
                                  :currentField="field"
                                  class="form__field"
                                ></component>
                              </div>
                              <div class="form__actiongroup">
                                <el-button-group class="form__actionlist hide_button" :class="{ 'show_party': componentFieldId === field.componentId,  }">
                                  <el-button
                                    size="mini"
                                    icon="el-icon-plus"
                                    @click="
                                      cloneElementField(
                                        index,
                                        field,
                                        eachFormObj.fields
                                      )
                                    "
                                    v-show="!field.isUnique"
                                  ></el-button>
                                </el-button-group>
                              </div>
                              <!-- <small class="form__helpblock" v-model="form.helpBlockText" v-show="form.isHelpBlockVisible">
                            {{ form.helpBlockText }}
                          </small> -->
                            </el-col>
                          </div>
                        </el-row>
                      </template>
                    </el-form>
                    <div class="row my-4 ml-4">
                      <div class="col-sm-2" v-for="(file , index) in filePath" :key="index">
                          <div class="card card-with-shadow border-0 ">
                            <div class="card-body text-center ">
                              <span>
                                <app-icon name="file"  />
                              </span>
                              <h6 class="mt-primary text-center"> {{ file.name }} </h6>
                            </div>
                          </div>
                          <div class="text-center my-4">
                              <a style="cursor:pointer" @click="removeFileAction(index)" class="d-block"> Remove  </a>
                              <a :href="file.path" download> Download  </a>
                          </div>
                      </div>
                    </div>
                    <div>
                      <el-button
                        style="margin-bottom: 10px"
                        type="secondary"
                        @click="saveForm"
                        >Save Form</el-button
                      >
                    </div>
                  </el-main>
                </el-container>
              </div>
            </div>
            <div
              class="scrollbar col-sm-4"
              id="style-1"
              :ref="componentFieldId"
            >
              <div class="force-overflow">
                <div
                  class="
                    card card-with-search
                    border-0
                    card-with-shadow
                    mb-primary
                  "
                  v-for="(v, i) in commentObject"
                  :key="i"
                  :class="{
                    'is---active': componentFieldId === i,
                  }"
                  @click="focusInput(i)"
                >
                  <div class="card-body pb-0">
               
                    <!-- <p>{{ commentText }}</p> -->
                    <div class="row">
                      <div class="col-sm-12">
                        <div
                          class="my-3"
                          v-for="(comm, commentindex) in v"
                          :key="commentindex"
                        >
                          <div
                            class="d-flex"
                            style="justify-content: space-between"
                          >
                            <app-media-object
                              :media-title="comm.user"
                              :media-subtitle="comm.created_at | formatDate"
                            />
                            <el-dropdown>
                              <el-button
                                type="primary"
                                class="btn btn-sm"
                                style="
                                  background: white;
                                  color: #4466f2;
                                  border: none;
                                "
                              >
                                <app-icon
                                  name="more-vertical"
                                  style="
                                    width: 10px !important;
                                    height: 10px !important;
                                  "
                                />
                              </el-button>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item>
                                  <span
                                    @click="editComment(commentindex, i, comm)"
                                  >
                                    Edit
                                  </span>
                                </el-dropdown-item>
                                <el-dropdown-item>
                                  <span
                                    @click="
                                      deleteComment(
                                        commentindex,
                                        i,
                                        comm.text_id
                                      )
                                    "
                                  >
                                    Delete
                                  </span>
                                </el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                          <p
                            style="
                              margin: 6px 0;
                              border-bottom: 1px solid rgb(137 137 137 / 53%);
                            "
                          >
                            {{ comm.text }}
                          </p>
                        </div>
                      </div>
                    </div>

                    <!-- <hr> -->
                  </div>
                  <!-- <p>{{ textComment }}</p> -->
                  <div class="card-body">
                    <input
                      type="text"
                      :v-bind-value="textComment[i]"
                      class="form-control my-2"
                      placeholder="Type Comment"
                      v-model="textComment[i]"
                      v-on:keyup.enter="enter(textComment, i)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import { FormBuilder } from "../../../CustomFormBuilder/form_elements/formbuilder";
import { axiosGet, axiosPost } from "../../../../../Helpers/AxiosHelper";
import {
  TASK_ASSIGN_FORM_SHOW,
  FORM_BUILDER_RESPONSE_POST,
  FORM_STATUS_STORE,
  FORM_INPUT_COMMENT_STORE,
  FORM_INPUT_COMMENT_LIST,
  FORM_INPUT_COMMENT_DELETE,
  FORM_INPUT_COMMENT_UPDATE,
} from "../../../../../Config/ApiUrl";

export default {
  name: "FormBuilderModal",
  components: FormBuilder.$options.components,
  mixins: [ModalMixin],
  props: {
    id: Number,
  },
  data() {
    return {
      // flag: null,
      uploadFilePathfinal: {},
      fieldId: [],
      textCommentId: 0,
      commentRequest: {},
      textComment: {},
      form_id: "",
      task_id: "",
      form_body_id: 0,
      forms: this.$store.state.formBuilder.forms,
      commentObject: {},
      commentText: "",
      componentFieldId: 0,
      themingVars: this.$store.state.formBuilder.themingVars,
      preloader: false,
      inputs: {
        yes: "no",
      },
      modalId: "form-view-Modal",
      modalTitle: this.$t("add"),
    };
  },
  methods: {
     removeFileAction(fileid){
      this.$store.state.uploadFilePath.dataUploadFilePath.splice(fileid , 1);
    },
    async getData() {
      // let form_id = this.getQueryParam();
      /**
       * * Pass the value to server, so that we can get required form response,
       * */

      axiosGet(`${TASK_ASSIGN_FORM_SHOW}/${this.id}`)
        .then((res) => {
          if (res.data.length !== 0) {
            this.forms = res.data.body;
            this.form_body_id = res.data.id;
            this.form_id = this.id;
            this.getInputsComments();
          }
        })
        .catch((res) => {
          console.error(res);
        });
    },
    saveForm() {
      // this.$attrs['currentField'].uploadURL = this.$store.state.uploadFilePath.dataUploadFilePath ;
      let formData = [];
      for (let formObj of this.forms) {
        let fieldCount = 0;
        for (let obj of formObj.fields) {
          if (
            obj.fieldType === "TextInput" ||
            obj.fieldType === "LongTextInput" ||
            obj.fieldType === "NumberInput" ||
            obj.fieldType === "SelectList" ||
            obj.fieldType === "RadioButton" ||
            obj.fieldType === "Checkbox" ||
            obj.fieldType === "TimePicker" ||
            obj.fieldType === "DatePicker" ||
            obj.fieldType === "DatetimePicker" ||
            obj.fieldType === "Upload" ||
            obj.fieldType === "UploadMediaFile"
          ) {
            formData.push({
              index: fieldCount,
              value: obj.componentValue,
              form_id: this.form_id,
              type: obj.fieldType,
              task_id: this.task_id,
            });
          }
          fieldCount++;
        }
      }
      axiosPost(FORM_BUILDER_RESPONSE_POST, {
        data: formData,
        id: this.form_body_id,
      })
        .then((res) => {
          this.$toastr.s(res.data.message);
          console.info(res);
        })
        .catch((res) => {
          console.error(res);
        });
    },
    getQueryParam() {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      return params.get("form_id");
    },
    // deleteElement(index, form) {
    //   FormBuilder.deleteElement(index, form);
    // },
    cloneElementField(index, field, form) {
    
      this.field_id = field.componentId;
      var idid = field.componentId;
      const text = field.text;
      const user = this.userRole.full_name;
      const val = [{ "user" : user }];
      this.commentObject[this.field_id] ?  this.commentObject[this.field_id].push({ 'user' : user}) :  this.$set(this.commentObject, this.field_id, val);
     
    },
    editElementProperties(fields) {
      this.commentText = fields.componentId;
      this.componentFieldId = fields.componentId;
    },
    focusInput(i) {
      // alert(i);

      this.componentFieldId = i;
    },
    enter(textComment, i) {
      this.commentRequest.comment = textComment[i];
      this.commentRequest.component_id = this.componentFieldId;
      this.commentRequest.form_body_id = this.form_body_id;
      this.commentRequest.text_id = this.textCommentId;

      if (this.textCommentId != 0) {
        
        axiosPost(FORM_INPUT_COMMENT_UPDATE, this.commentRequest)
          .then((res) => {
            this.$toastr.s(res.data.message);
          })
          .catch((res) => {
            this.$toastr.e(res.data.error);
          })
          .finally(() => {
            this.$set(this.textComment, i, "");
            this.textCommentId = 0;
            this.getInputsComments();
          });
      } else {
        
        textComment[i]
          ? axiosPost(FORM_INPUT_COMMENT_STORE, this.commentRequest)
              .then((res) => {
                this.$toastr.s(res.data.message);
              })
              .catch((res) => {
                this.$toastr.e(res.data.error);
              })
              .finally(() => {
                this.$set(this.textComment, i, "");
                this.getInputsComments();
              })
          : this.$toastr.e("Please fill comment box ");
      }
    },
    editComment(commentindex, i, comm) {
      this.$set(this.textComment, i, comm.text);
      this.textCommentId = comm.text_id;

      
      if (this.textComment !== null) {
        this.reloadfun(i);
        this.focusInput(i);
      }
    },
    deleteComment(commentindex, i, id) {
      axiosGet(FORM_INPUT_COMMENT_DELETE + "/" + id)
        .then((res) => {
          this.$toastr.s(res.data.message);
        })
        .catch((res) => {
          console.error(res);
        })
        .finally(() => {
          this.getInputsComments();
        });
    },
    reloadfun(i) {
      // 
      return this.textComment[i];
    },

    getInputsComments() {
      axiosGet(FORM_INPUT_COMMENT_LIST + "/" + this.form_body_id)
        .then((res) => {
          if (res.data.length !== 0) {
            // 
            
            this.commentObject = res.data;
          }
        })
        .catch((res) => {
          console.error(res);
        });
    },
  },
  created() {
    this.getData();
  },
  
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    filePath(){
      return this.$store.state.uploadFilePath.dataUploadFilePath ;
      //  this.$store.dispatch("setValueToPass", documents);
    },
    cssProps() {
      // Return an object that will generate css properties key
      // to match with the themingVars
      //
      // Example output: { '--theme-primary-color': this.themingVars.primaryColor }
      var result = {},
        themingVars = this.themingVars;

      for (var v in themingVars) {
        if (themingVars.hasOwnProperty(v)) {
          var newV = "--theme-" + _.kebabCase(v),
            suffix = "";

          // Add px to the value if the default value contain 'px'
          if (_.includes(newV, "size")) suffix = "px";
          else if (_.includes(newV, "margin")) suffix = "px";
          else if (_.includes(newV, "radius")) suffix = "px";

          result[newV] = themingVars[v] + suffix;
        }
      }

      return result;
    },
  },
  mounted() {
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
};
</script>
<style scoped>
.is---active {
  background: #e5ebfb;
}
.scrollbar {
  height: 700px;
  background: #f5f5f5;
  overflow-y: scroll;
}

.force-overflow {
  min-height: 450px;
}

#style-1::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}

#style-1::-webkit-scrollbar {
  width: 5px;
  background-color: #f5f5f5;
}

#style-1::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px var(--scrollbar-thumb-color);
  background: var(--scrollbar-thumb-color);
}
.hide_button {
  display: none;
}
.show_party {
  display:  block !important;
  float: right;
}
</style>
